import React, { useEffect } from 'react';
import './Contact.css';
import Navbar from '../Navbar/Navbar';
import ContactForm from '../ContactForm/ContactForm';
import SocialMediaGrid from '../SocialMediaGrid/SocialMediaGrid';
import Footer from '../../components/Footer/Footer';
// import FluidBackground from '../../components/FluidBackground/FluidBackground';
import ParticleBackground from '../../components/ParticleBackground/ParticleBackground';

const Contact = () => {
  // Create many blobs positioned far above the screen
  useEffect(() => {
    const pageDecoration = document.querySelector('.page-decoration');
    if (!pageDecoration) return;
    
    // Create a blob with specific vertical position and horizontal bias
    const createBlob = (verticalPosition, horizontalBias = null) => {
      const blob = document.createElement('div');
      blob.className = 'floating-blob';
      
      // Randomize horizontal position with optional bias
      let leftPosition;
      if (horizontalBias === 'far-left') {
        leftPosition = -5 + Math.random() * 15; // -5% to 10% (far left edge)
      } else if (horizontalBias === 'left') {
        leftPosition = 10 + Math.random() * 20; // 10% to 30% (left side)
      } else if (horizontalBias === 'center') {
        leftPosition = 30 + Math.random() * 40; // 30% to 70% (center)
      } else if (horizontalBias === 'right') {
        leftPosition = 70 + Math.random() * 20; // 70% to 90% (right side)
      } else if (horizontalBias === 'far-right') {
        leftPosition = 90 + Math.random() * 15; // 90% to 105% (far right edge)
      } else {
        leftPosition = 5 + Math.random() * 90; // 5% to 95% (full width)
      }
      
      blob.style.left = `${leftPosition}%`;
      
      // Set vertical position (negative to be above the viewport)
      blob.style.top = `${verticalPosition}px`;
      
      // Randomize size
      const size = 100 + Math.random() * 200; // Random size between 100px and 300px
      blob.style.width = `${size}px`;
      blob.style.height = `${size}px`;
      
      // Randomize opacity and color intensity
      const opacity = 0.25 + Math.random() * 0.15; // Between 0.25 and 0.4
      blob.style.background = `rgba(227, 41, 97, ${opacity})`;
      
      // Set parallax speed
      blob.dataset.speed = 0.2 + Math.random() * 0.2; // Random speed between 0.2 and 0.4
      
      return blob;
    };
    
    // Create blobs with better distribution
    const totalBlobs = 65;
    const blobs = [];
    
    // Position blobs from -15000px up to the top of the viewport
    // with even distribution across far-left, left, center, right, and far-right
    for (let i = 0; i < totalBlobs; i++) {
      const verticalPosition = -15000 + (i * (15000 / totalBlobs));
      
      // Determine horizontal bias based on position
      let horizontalBias;
      const position = i % 5;
      if (position === 0) horizontalBias = 'far-left';
      else if (position === 1) horizontalBias = 'left';
      else if (position === 2) horizontalBias = 'center';
      else if (position === 3) horizontalBias = 'right';
      else horizontalBias = 'far-right';
      
      const blob = createBlob(verticalPosition, horizontalBias);
      pageDecoration.appendChild(blob);
      blobs.push(blob);
    }
    
    // Add extra blobs near the top with explicit edge bias
    for (let i = 0; i < 15; i++) {
      // Cycle through all positions for the extra blobs
      const positions = ['far-left', 'left', 'center', 'right', 'far-right'];
      const horizontalBias = positions[i % 5];
      const verticalPosition = -500 - (i * 300); // Position between -500px and -4900px
      const blob = createBlob(verticalPosition, horizontalBias);
      pageDecoration.appendChild(blob);
      blobs.push(blob);
    }
    
    // Add specific blobs at the far left edges
    for (let i = 0; i < 5; i++) {
      const verticalPosition = -1000 - (i * 800); // Well-spaced vertical positions
      const blob = createBlob(verticalPosition, 'far-left');
      pageDecoration.appendChild(blob);
      blobs.push(blob);
    }
    
    // Handle scroll to move blobs with parallax effect
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      const viewportHeight = window.innerHeight;
      
      // Update all blobs position
      blobs.forEach((blob) => {
        const speed = parseFloat(blob.dataset.speed) || 0.3;
        const initialTop = parseInt(blob.style.top) || 0;
        
        // Apply parallax movement
        blob.style.transform = `translateY(${currentScrollY * speed}px)`;
        
        // Calculate actual position
        const blobTop = initialTop + (currentScrollY * speed);
        
        // Make blobs visible only when they're near or in the viewport
        if (blobTop < -viewportHeight || blobTop > viewportHeight * 2) {
          blob.style.opacity = '0';
        } else {
          // Fade in as they approach the viewport
          const distance = Math.abs(blobTop);
          const maxDistance = viewportHeight;
          // Opacity range: minimum 0.2, maximum 0.5
          const opacity = 0.2 + (0.3 * (1 - Math.min(distance / maxDistance, 1)));
          blob.style.opacity = opacity.toString();
        }
      });
    };
    
    window.addEventListener('scroll', handleScroll);
    
    // Call once to set initial positions
    handleScroll();
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
      // Clean up blobs
      blobs.forEach(blob => {
        if (pageDecoration.contains(blob)) {
          pageDecoration.removeChild(blob);
        }
      });
    };
  }, []);
  
  return (
    <div className="contact-page-container">
      
      {/* <FluidBackground /> */}
      <ParticleBackground />
      
      {/* Container for dynamically created blobs */}
      <div className="page-decoration"></div>
      
      <div className="content-wrapper">
        <Navbar />
        
        <div className="contact-page-header">
          <h1>Contact Us</h1>
          <p>We'd love to hear from you. Reach out through our contact form or connect with us on social media.</p>
        </div>
        
        <div className="contact-social-section-wrapper">
          <div className="contact-social-section">
            <div className="contact-side">
              <ContactForm />
            </div>
            <div className="social-side">
              <SocialMediaGrid />
            </div>
          </div>
        </div>
      </div>
      
      <style>
        {`
          .dg.ac {
            display: none !important;
          }
          
          /* Page-wide blob styling */
          .page-decoration {
            position: fixed;
            top: 0;
            left: 0;
            width: 100vw;
            height: 100vh;
            minHeight: 100vh;
            minHeight: 100dvh; /* Better mobile support */
            pointer-events: none;
            z-index: 1;
            overflow: hidden;
          }
          
          .floating-blob {
            position: absolute;
            border-radius: 50%;
            filter: blur(15px);
            box-shadow: 0 0 25px rgba(227, 41, 97, 0.5);
            will-change: transform, opacity;
            transition: opacity 0.5s ease;
          }
          
          /* Ensure particles background covers full screen on all devices */
          .particle-background-container {
            position: fixed !important;
            top: 0 !important;
            left: 0 !important;
            width: 100vw !important;
            height: 100vh !important;
            min-height: 100vh !important;
            min-height: 100dvh !important; /* Better mobile support */
            min-height: -webkit-fill-available !important; /* Safari/Mac fix */
            z-index: 0 !important;
            pointer-events: none !important;
          }
          
          /* Content wrapper */
          .content-wrapper {
            position: relative;
            z-index: 2;
            min-height: 100vh;
            display: flex;
            flex-direction: column;
            width: 100%;
            overflow-x: hidden;
          }
          
          /* Contact page header */
          .contact-page-header {
            text-align: center;
            padding: 120px 20px 40px;
            max-width: 800px;
            margin: 0 auto;
            width: 100%;
            box-sizing: border-box;
          }
          
          .contact-page-header h1 {
            font-size: 3rem;
            margin-bottom: 1rem;
            color: #fff;
            font-weight: 700;
            text-shadow: 0 0 15px rgba(227, 41, 97, 0.7);
          }
          
          .contact-page-header p {
            font-size: 1.2rem;
            color: rgba(255, 255, 255, 0.8);
            line-height: 1.6;
            margin: 0;
          }
          
          /* Contact and Social section wrapper */
          .contact-social-section-wrapper {
            flex: 1;
            width: 100%;
            padding: 0 20px;
            box-sizing: border-box;
            display: flex;
            justify-content: center;
            align-items: flex-start;
            margin-bottom: 40px;
          }
          
          .contact-social-section {
            display: flex;
            flex-direction: row;
            width: 100%;
            max-width: 1400px;
            margin: 0 auto;
            align-items: stretch;
            gap: 40px;
            box-sizing: border-box;
          }
          
          .contact-side {
            flex: 1;
            display: flex;
            justify-content: center;
            align-items: stretch;
            min-width: 0;
            max-width: 50%;
            min-height: 600px;
            padding: 20px;
            box-sizing: border-box;
            overflow: hidden;
            position: relative;
            z-index: 15;
          }
          
          .social-side {
            flex: 1;
            display: flex;
            justify-content: center;
            align-items: stretch;
            min-width: 0;
            max-width: 50%;
            min-height: 600px;
            padding: 20px;
            box-sizing: border-box;
            overflow: hidden;
            position: relative;
            z-index: 15;
          }
          
          /* Make sure child components fit properly */
          .contact-side > *,
          .social-side > * {
            max-width: 100%;
            width: 100%;
            height: 100%;
            min-height: 100%;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
          }
          
          /* Ensure all child elements respect container boundaries */
          .contact-side *,
          .social-side * {
            max-width: 100%;
            box-sizing: border-box;
          }
          
          /* Ensure form elements are properly sized */
          .contact-side input,
          .contact-side textarea,
          .contact-side select,
          .contact-side button {
            max-width: 100%;
            box-sizing: border-box;
            position: relative;
            z-index: 20;
            pointer-events: auto;
          }
          
          /* Mobile responsive adjustments */
          @media (max-width: 768px) {
            .contact-page-header {
              padding: 100px 15px 30px;
            }
            
            .contact-page-header h1 {
              font-size: 2.5rem;
            }
            
            .contact-page-header p {
              font-size: 1.1rem;
            }
            
            .contact-social-section-wrapper {
              padding: 0 15px;
            }
            
            .contact-social-section {
              flex-direction: column;
              align-items: center;
              gap: 30px;
              max-width: 600px;
              margin: 0 auto;
            }
            
            .contact-side,
            .social-side {
              width: 100%;
              max-width: 100%;
              min-height: auto;
              padding: 15px;
              display: flex;
              justify-content: center;
              align-items: center;
            }
            
            /* Override child component alignment for mobile */
            .contact-side .contact-section,
            .social-side .social-media-section {
              align-items: center !important;
              justify-content: center !important;
              text-align: center !important;
              width: 100% !important;
              max-width: 100% !important;
            }
            
            .contact-side .contact-container,
            .social-side .social-media-container {
              margin: 0 auto !important;
              align-self: center !important;
              width: 100% !important;
              max-width: 100% !important;
            }
            
            .contact-side .contact-text,
            .social-side .social-media-text {
              text-align: center !important;
            }
          }
          
          @media (max-width: 480px) {
            .contact-page-header {
              padding: 90px 10px 20px;
            }
            
            .contact-page-header h1 {
              font-size: 2rem;
            }
            
            .contact-page-header p {
              font-size: 1rem;
            }
            
            .contact-social-section-wrapper {
              padding: 0 10px;
            }
            
            .contact-social-section {
              max-width: 100%;
              gap: 20px;
            }
            
            .contact-side,
            .social-side {
              padding: 10px;
            }
          }
          
          /* Mobile-specific fixes for particle background */
          @media screen and (max-width: 768px) {
            .contact-page-container {
              min-height: 100vh;
              min-height: 100dvh; /* Dynamic viewport height for mobile */
              min-height: -webkit-fill-available; /* Safari fallback */
            }
            
            .particle-background-container,
            .page-decoration {
              position: fixed !important;
              top: 0 !important;
              left: 0 !important;
              width: 100vw !important;
              height: 100vh !important;
              min-height: 100vh !important;
              min-height: 100dvh !important;
              min-height: -webkit-fill-available !important;
              max-height: none !important;
              z-index: 0 !important;
            }
            
            /* Ensure tsparticles canvas covers full screen */
            #tsparticles {
              position: fixed !important;
              top: 0 !important;
              left: 0 !important;
              width: 100vw !important;
              height: 100vh !important;
              min-height: 100vh !important;
              min-height: 100dvh !important;
              min-height: -webkit-fill-available !important;
            }
          }
          
          /* Mac/Safari specific fixes for full viewport coverage */
          @media screen and (-webkit-min-device-pixel-ratio: 1) {
            .particle-background-container,
            .page-decoration {
              height: 100vh !important;
              min-height: 100vh !important;
              min-height: -webkit-fill-available !important;
            }
            
            #tsparticles {
              height: 100vh !important;
              min-height: 100vh !important;
              min-height: -webkit-fill-available !important;
            }
          }
          
          /* Additional Safari-specific fix */
          @supports (-webkit-appearance: none) and (not (contain: paint)) {
            .particle-background-container,
            .page-decoration,
            #tsparticles {
              height: calc(100vh + 1px) !important;
              min-height: calc(100vh + 1px) !important;
            }
          }
        `}
      </style>
      <Footer />
    </div>
  );
};

export default Contact; 